import { AxiosPromise } from "axios";
import { apiWrapper } from "../../axiosInstance";
import { ColorMappingServiceResponse } from "./colorMapping.service";

export const colorMappingEndpoint = (): AxiosPromise<ColorMappingServiceResponse> =>
    apiWrapper.instance!.get(`rest/sdo/changeTypeColorMapping`);
